import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { canActivateGuards } from '../app-routing.module';
import { NewHomeComponent } from './pages/new-home/new-home.component';

const routes: Routes = [
  {
    path: 'home',
    canActivate: canActivateGuards,
    component: NewHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
